module.exports = "<div layout=column layout-fill ng-class=\"{show: vm.showHeader === undefined || vm.showHeader === null || vm.showHeader}\" class=gz-body><printos-header><div style=\"box-sizing:border-box;min-height:64px;border-bottom:2px solid #0096d6;background:#fff\"></div></printos-header><div flex layout=row ng-cloak class=gz-app-content><gz-app-nav items=vm.navItems() is-nav-ux=vm.isNavUx></gz-app-nav><md-content flex><gz-view-container translate-cloak><ui-view layout-fill></ui-view></gz-view-container></md-content></div></div>";


//////////////////
// WEBPACK FOOTER
// ../~/@printos/gazelle/src/components/body-wrap/body-wrap.jade
// module id = 228
// module chunks = 0